const API_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_BASE_URL_DEV
    : process.env.REACT_APP_API_BASE_URL;

export async function fetchWorkers(env = 'memo') {
  const res = await fetch(`${API_BASE_URL}/workers?env=${env}`);
  if (!res.ok) throw new Error('Failed to fetch workers');
  return res.json();
}
